<template>
  <b-overlay :show="loading" rounded="sm">
    <b-card class="landing-item">
      <h4 v-text="editing ? 'ویرایش لندینگ' : 'لندینگ جدید'" class="mb-2" />
      <b-row>
        <b-col md="12" lg="8" offset-lg="2">
          <b-row>
            <b-col md="12">
              <b-form-group label="عنوان">
                <b-form-input
                    v-model="form.Key"
                    autocomplete="off"
                    type="tel"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <fm-file-select v-model="form.Video" type="video" label="ویدئو" :entity="1" />
            </b-col>
            <b-col md="6">
              <fm-file-select v-model="form.VideoCover" label="کاور ویدئو" :entity="1" />
            </b-col>
            <b-col md="12">
              <fm-file-select v-model="form.MobileMocap" type="video" label="موبایل موکاپ" :entity="1" />
            </b-col>
            <b-col md="6">
              <b-form-group label="بنر">
                <banner-type-select type="2" v-model="form.TopBannerId" />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="استیکی بنر">
                <banner-type-select type="1" v-model="form.StickyBannerId" />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="توضیحات بالا">
                <b-form-textarea
                    v-model="form.TopDescription"
                    autocomplete="off"
                    rows="6"
                    no-resize
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="توضیحات فرم بالا">
                <b-form-textarea
                    v-model="form.TopFormDescription"
                    autocomplete="off"
                    rows="6"
                    no-resize
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group label="توضیحات پایین">
                <b-form-textarea
                    v-model="form.DownDescription"
                    autocomplete="off"
                    rows="4"
                    no-resize
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group label="انخاب چرخونک">
                <lucky-wheel-select v-model="form.PrizeWheelId" :multiple="false"></lucky-wheel-select>
              </b-form-group>
            </b-col>
          </b-row>
          <div class="mt-2">
            <h4 class="mb-1">ویژگی ها</h4>
            <div>
              <div
                  v-for="(item, i) in form.Attribute"
                  :key="i"
                  class="flex-grow-1 border mb-1 p-1 position-relative"
              >
                <b-row>
                  <b-col md="12">
                    <b-form-group
                        label="عنوان"
                        class="flex-grow-1"
                    >
                      <b-form-input
                          v-model="form.Attribute[i].Title"
                          autocomplete="off"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group label="توضیحات">
                      <b-form-textarea
                          v-model="form.Attribute[i].Description"
                          autocomplete="off"
                          rows="4"
                          no-resize
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <fm-file-select v-model="form.Attribute[i].Image" label="عکس" :entity="1" />
                  </b-col>
                  <b-col md="6">
                    <fm-file-select v-model="form.Attribute[i].Icon" label="آیکون" :entity="1" />
                  </b-col>
                </b-row>
                <b-button
                    v-if="form.Attribute.length > 1"
                    class="btn-icon rounded-circle"
                    variant="danger"
                    size="sm"
                    style="position: absolute;top: -5px;left: -5px"
                    @click="deleteAttribute"
                >
                  <feather-icon icon="TrashIcon" />
                </b-button>
              </div>
              <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  @click="addAttribute"
              >
                <feather-icon
                    icon="PlusIcon"
                    class="mr-25"
                />
                <span>ویژگی جدید</span>
              </b-button>
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-center mt-4">
            <b-button variant="primary" class="mr-1" @click="submit">
              ذخیره
            </b-button>
            <b-button :to="{ name: 'landings'}">
              بازگشت
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </b-overlay>
</template>

<script>
import FmFileSelect from "@/views/menu/file-manager/components/fmFileSelect.vue";
import BannerTypeSelect from "@/tools/media/bannerTypeSelect.vue";
import luckyWheelSelect from "@/tools/luckyWheel.vue";
export default {
  name: "productItem",
  components: { FmFileSelect, BannerTypeSelect,luckyWheelSelect },
  data() {
    return {
      loading: false,
      form: {
        Key: '',
        TopDescription: '',
        DownDescription: '',
        TopFormDescription: '',
        TopBannerId: '',
        StickyBannerId: '',
        Video: '',
        VideoCover: '',
        MobileMocap: '',
        Attribute: [],
        luckyWheelSelect:null,
        PrizeWheelId:null
      },
      attribute: {
        Title: '',
        Description: '',
        Image: '',
        Icon: '',
      },
    }
  },
  computed: {
    editing() {
      return this.$route.params.id
    }
  },
  watch: {
    editing: {
      immediate: true,
      handler(val) {
        if (val !== '' && val !== undefined) this.get()
        else this.form.Attribute.push(this.attribute)
      }
    }
  },
  methods: {
    get() {
      this.loading = true
      this.$http.post(this.$api.landing.get, { Id: this.editing })
          .then(res => {
            this.loading = false
            this.form = res.data
          }).catch(() => {
        this.loading = false
      })
    },
    submit() {
      /*this.form.PropertyList = this.propertyItems.join(';')
      for (let i in this.form) {
        if (this.form[i] === '' || this.form[i] === null)
          return this.$bvToast.toast('لطفا همه فیلد ها را پر کنید', {
            title: 'خطا در انجام عملیات',
            toaster: 'b-toaster-bottom-right',
            variant: 'danger',
            solid: false,
            appendToast: true,
          })
      }*/
      this.loading = true

      let url = this.editing ? this.$api.landing.edit : this.$api.landing.add

      let data = { ...this.form }
      if (this.editing) data.Id = this.editing

      this.$http.post(url, data)
          .then(() => {
            this.loading = false
            this.$router.back()
          }).catch(() => {
        this.loading = false
      })
    },
    addAttribute() {
      this.form.Attribute.push({ ...this.attribute })
      this.attribute = null
    },
    deleteAttribute(index) {
      this.form.Attribute.splice(index, 1)
    },
  }
}
</script>